import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FocusInputType, KeyValueId, LocalService } from 'src/service/local.service';

@Component({
  selector: 'app-bill-staff',
  templateUrl: './bill-staff.component.html',
  styleUrl: './bill-staff.component.scss'
})
export class BillStaffComponent {
  @Input() key: string = '';
  @Input() header: string = '';
  @Input() createdByName: string = '';
  @Input() createdByLanguage: string = '';
  @Input() staffId: string = '';
  @Input() businessId: string = '';
  @Input() placeHolder: string = 'Enter here..';
  @Input() isReadOnly: boolean = false;

  @Input() isOpen: boolean = false;
  @Output() isOpenChange = new EventEmitter();
  @Output() onSave = new EventEmitter();
  @Input() isChildPopupOpened = false;

  elementIds: any = {
    txt_update: 'txt-update',
    brn: 'brn'
  };

  constructor(public localService: LocalService) { }

  ngOnChanges(): void {
    this.localService.onFocusNextInput(this.elementIds.txt_update, FocusInputType.TextBox);
  }

  close() {
    this.isOpen = false;
    this.isOpenChange.emit(this.isOpen);
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.close();
      } break;
      case 2: {
        this.onSave.emit({ key: this.key, value: this.staffId.trim() } as KeyValueId);
        this.close();
      } break;
    }
  }

  onUserUpdated(strUserId, index) {
    this.staffId = strUserId;
  }
}
